import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-not-found",
  standalone: true,
  imports: [RouterModule],
  templateUrl: "./not-found.component.html",
  styleUrl: "./not-found.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {}
